<mat-sidenav-container
  class="example-container"
  [hasBackdrop]="false"
  [@.disabled]="sidenavService.temporaryDisabled"
>
  <!-- leftSideNav -->

  <mat-sidenav
    id="left_panel"
    [ngStyle]="{ transition: 'all 0.6s linear , top 0s linear  ' }"
    #leftSidenav
    mode="over"
    [fixedInViewport]="true"
    [fixedTopGap]="84"
    [ngClass]="[HideForEmbed ? 'map-sidenav-hide' : 'map-sidenav']"
  >
    <mat-nav-list>
      <mat-list-item class="logo-heading">
        <h3 class="toolname">
          <img class="bottom" src="{{ url }}" />
          {{ toolName }}
        </h3>
      </mat-list-item>
      <!-- Component render here -->
      <div #container></div>
      <!-- Component render here  end -->
    </mat-nav-list>
  </mat-sidenav>

  <!-- Content -->
  <mat-sidenav-content class="content">
    <app-map></app-map>
  </mat-sidenav-content>
  <!-- rightSideNav -->
  <mat-sidenav
    [style.width.px]="sidenavWidth"
    id="right_panel"
    [hidden]="sidenavService.hideRightPanelForImage"
    [ngStyle]="{
      transition: sidenavService.showAnimateNow
        ? '0s'
        : 'all 0.6s linear , top 0s linear ,width 0s linear'
    }"
    #rightSideNav
    mode="over"
    position="end"
    [fixedInViewport]="true"
    [fixedTopGap]="84"
    [ngClass]="[menu1?.id !== 15 ? 'map-sidenav-left' : 'map-sidenavInfo']"
  >
    <mat-nav-list>
      <!-- Component render here -->
      <div #Rightcontainer></div>
    </mat-nav-list>
  </mat-sidenav>
</mat-sidenav-container>
